<template>
    <div class="flex flex-col items-start">
        <h2 class="text-2xl lg:text-4xl font-semibold leading-tight text-center lg:text-left">
            <slot></slot>
        </h2>

        <div class="mt-5 pt-5 border-t border-zinc-300 w-full">
            <div v-if="showLocationSelector" class="flex items-center">
                <svg class="text-neutral-900 mr-3 w-5 h-5" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.5 8.33301C16.5 14.1663 9 19.1663 9 19.1663C9 19.1663 1.5 14.1663 1.5 8.33301C1.5 6.34388 2.29018 4.43623 3.6967 3.02971C5.10322 1.62318 7.01088 0.833008 9 0.833008C10.9891 0.833008 12.8968 1.62318 14.3033 3.02971C15.7098 4.43623 16.5 6.34388 16.5 8.33301Z" stroke="#171717" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 10.833C10.3807 10.833 11.5 9.71372 11.5 8.33301C11.5 6.9523 10.3807 5.83301 9 5.83301C7.61929 5.83301 6.5 6.9523 6.5 8.33301C6.5 9.71372 7.61929 10.833 9 10.833Z" stroke="#171717" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                <div class="pl-3 border-l border-zinc-300 text-sm font-medium flex justify-between lg:justify-start items-center w-full">
                    <div>
                        <span>{{ city }}, {{ state }}</span> -
                        <span v-text="countyName"></span>
                    </div>

                    <button
                        type="button"
                        class="lg:ml-2 px-1 py-0.5 underline transition-colors rounded-md text-sm text-brand-blue hover:text-brand-blue-darker focus:outline-none focus:ring-2 ring-brand-blue ring-offset-2"
                        @click="showModal"
                    >
                        Update
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { get, isEmpty } from 'lodash';
import { mapGetters } from 'vuex';

import BaseButton from "../BaseButton";

export default {
    components: {
        BaseButton,
    },

    props: {
        showLocationSelector: {
            type: Boolean,
            default: true,
        }
    },

    mounted() {
        this.fetchCounties();
    },

    computed: {
        ...mapGetters('lead', [
            'city',
            'countyName',
            'form',
            'locationId',
            'regions',
            'state'
        ]),

        /**
         * @returns {boolean}
         */
        missingCounties() {
            return isEmpty(this.regions);
        }
    },

    methods: {
        /**
         * Fires event to open counties modal.
         */
        showModal() {
            this.$event.$emit('regions-modal:show');
        },

        /**
         * Get counties for given location id.
         */
        fetchCounties () {
            const config = {
                params: {
                    criteria_id: this.locationId,
                }
            };

            axios.get('/api/counties', config)
                .then(({ data }) => {
                    this.$store.commit('lead/regions', data.data.data);
                    this.$store.commit('lead/selectedRegion', data.data.data[0]);
                    this.$store.commit('lead/disambiguate', data.data.disambiguations);
                    this.$store.commit('lead/updateForm', {
                        region_id: get(this.regions, '0.criteria_id')
                    });
                })
                .catch(error => {
                    if (error.response.status != 422) {
                        let data = JSON.parse(window.localStorage.getItem('lcsForm'));
                        data.error = error;
                        this.$emit('error', error.response);
                        window.bugsnagClient.notify(JSON.stringify(data));
                    }

                    this.$event.$emit('step:specific', 1);
                })
                .finally(() => {
                    this.afterCountiesLoaded();
                });
        },

        /**
         * Check a few things related to counties and redirect to different step if needed.
         */
        afterCountiesLoaded () {
            if (
                this.form.region_id
                && ! this.form.errors.any()
                && this.disambiguate
            ) {
                this.$event.$emit('step:specific', 1);
            }
        }
    }
};
</script>
